import './App.css';
import {BrowserRouter,Routes,Route} from "react-router-dom"
import Layout from './components/Layout';
import Home from "./pages/Home/Home"
import Event from "./pages/Event/Events"
import Sponser from "./pages/Sponser/Sponser"
import About from "./pages/About/About"
import Contact from "./pages/Contact/Contact"
import MovieMania from './EvtPages/MovieMania/MovieMania';
import Googler from './EvtPages/Googler/Googler';
import Project from './EvtPages/ProjectExpo/Project';
import Lan from './EvtPages/LAN/Lan';
import Dronathon from './EvtPages/Dronathon/Dronathon';
import IPL from './EvtPages/IplAuction/IPL';
function App() {
  return (
    <>
    <BrowserRouter>
    <Routes>
      <Route path='/' element={<Layout/>}>
        <Route index element={<Home/>}/>
        <Route path='Events' element={<Event/>}/>
        <Route path='Sponser' element={<Sponser/>}/>
        <Route path='About' element={<About/>}/>
        <Route path='Contact' element={<Contact/>}/>
        <Route path='Movie-Mania' element={<MovieMania/>}/>
        <Route path='Googler' element={<Googler/>}/>
        <Route path='Project-Expo' element={<Project/>}/>
        <Route path='Lan' element={<Lan/>}/>
        <Route path='Dronathon' element={<Dronathon/>}/>
        <Route path='IPL' element={<IPL/>}/>
      </Route>
    </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;
